// Admin Help Center service — reuses the admin axios instance (carries the
// httpOnly cookie + 401 interceptor) exported by adminService.js.
import adminApi from './adminService';

export const helpAdminService = {
  // Categories
  async getCategories() {
    const response = await adminApi.get('/admin/help/categories');
    return response.data;
  },
  async createCategory(payload) {
    const response = await adminApi.post('/admin/help/categories', payload);
    return response.data;
  },
  async updateCategory(id, payload) {
    const response = await adminApi.put(`/admin/help/categories/${id}`, payload);
    return response.data;
  },
  async reorderCategories(items) {
    const response = await adminApi.post('/admin/help/categories/reorder', { items });
    return response.data;
  },

  // Articles
  async getArticles(categoryId) {
    const params = categoryId ? { category_id: categoryId } : {};
    const response = await adminApi.get('/admin/help/articles', { params });
    return response.data;
  },
  async getArticle(id) {
    const response = await adminApi.get(`/admin/help/articles/${id}`);
    return response.data;
  },
  async createArticle(payload) {
    const response = await adminApi.post('/admin/help/articles', payload);
    return response.data;
  },
  async updateArticle(id, payload) {
    const response = await adminApi.put(`/admin/help/articles/${id}`, payload);
    return response.data;
  },
  async setArticleStatus(id, status) {
    const response = await adminApi.post(`/admin/help/articles/${id}/status`, { status });
    return response.data;
  },
  async deleteArticle(id) {
    const response = await adminApi.delete(`/admin/help/articles/${id}`);
    return response.data;
  },
  async reorderArticles(items) {
    const response = await adminApi.post('/admin/help/articles/reorder', { items });
    return response.data;
  },
};
